module.exports = __webpack_public_path__ + "img/parker-shelton-logo.c438e3a4.webp";